import { render, staticRenderFns } from "./QualityTestingGG.vue?vue&type=template&id=0ec08f4c&scoped=true"
import script from "./QualityTestingGG.vue?vue&type=script&lang=js"
export * from "./QualityTestingGG.vue?vue&type=script&lang=js"
import style0 from "./QualityTestingGG.vue?vue&type=style&index=0&id=0ec08f4c&prod&lang=css"
import style1 from "./QualityTestingGG.vue?vue&type=style&index=1&id=0ec08f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec08f4c",
  null
  
)

export default component.exports